import { truncate } from '../utils'

export default {
  methods: {
    truncate
  }
}
